import {uploadFileApi} from "@/api/uploadFileApi";
import {saveSpaceStationApi, getSpaceStationDetailById} from "@/api/spaceStationApi";
import Tinymce from "@/components/Tinymce/index.vue";
import {getPlaceSuggestionApi} from "@/api/qq-map";
import {getJdRegionList} from "@/api/jdRegionApi";


export const addOrUpdateSpaceStation = {
    props: {},
    data() {
        return {
            echoAfter: true,
            isStartNum: 1,
            imgList: [],
            categoryOne: [],
            categoryTwo: [],
            categoryThree: [],
            deliveryList: [],
            freight: [],
            installList: [],
            isJdUrl: "1",
            goodsUrl: "",
            // 商品信息
            goodsInfo: {
                id: "",
                title: "",
                businessHours: "",
                tel: "",
                address: "",
                isShow: "",
                sortNum: "",
                lat: 39.908823,
                lng: 116.39747,
                storeCity: "",
                detail:"",
                picUrl:'',
                pro:'',
                city:'',
            },
            valueSize: 0,
            valueList: [],
            arr: [],
            specialSpec: null,
            specialSpecObj: {},
            specialSpecArr: [],
            status: 0,
            goodsStatus: "",
            role: [],
            map: null,
            marker: null,
            mapLocation: {
                lat: "",
                lng: ""
            },
            timeout: null,
            proList:[],
            cityList:[]
        };
    },
    methods: {


        //初始化省份
        async initPro(pId) {
            let {data} = await getJdRegionList({
                pId: pId || 0,
            });

            this.proList=data

        },

        async findCity() {
            let {data} = await getJdRegionList({
                pId: this.goodsInfo.pro,
            });

            this.cityList=data

        },

        //移除图片
        async removeImages(item, index) {
            this.imgList.splice(index, 1);
            // if ((this.goodsInfo.spuId =="" && this.goodsInfo.id =="") || (this.goodsInfo.spuId !="" && this.goodsInfo.id !="") ) {

            // }
        },
        // 移除销售规格
        removeValue(index) {
            this.arr.splice(index, 1);
        },
        //保存
        async saveGoodsInfo(e) {

            if (e === 1) {
                this.goodsInfo.id = null;
            }
            if (this.goodsStatus == 1) {
                this.goodsInfo.id = "";
            }
            if (!this.ruleForm()) {
                return;
            }
            let {data} = await saveSpaceStationApi(this.goodsInfo);
            this.$swal.fire({
                icon: "success",
                title: "保存成功",
                toast: true,
                position: "center",
                showConfirmButton: false,
                timer: 2000,
            });
            if (e == 0) {
                this.$router.push("/spaceStation");
            }
        },
        // 表单规则
        ruleForm() {

            //检查商品标题
            if (!this.goodsInfo.title) {
                this.$swal.fire({
                    icon: "warning",
                    title: "请填写标题",
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 2000,
                });
                return false;
            }
            //检查副标题"
            if (!this.goodsInfo.businessHours) {
                this.$swal.fire({
                    icon: "warning",
                    title: "请填写营业时间",
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 2000,
                });
                return false;
            }

            //检查亮点
            if (!this.goodsInfo.tel) {
                this.$swal.fire({
                    icon: "warning",
                    title: "请填写联系电话",
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 2000,
                });
                return false;
            }

            return true;
        },
        // saveGoodsInfo() {},
        uploadSuccess(res, fileList) {
            this.imgList.push(res.data.fileUrl);
        },
        //上传文件
        async uploadFileAvatar(event) {
            const file = event.target.files[0];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("moduleName", "spaceStation");
            let {data} = await uploadFileApi(formData);
            this.goodsInfo.picUrl = data.fileUrl;
        },

        //移除主图
        romverAvatar() {
            this.goodsInfo.picUrl = "";
        },


        switchInputShow(value) {
            // 在 @input 事件中手动同步数据
            if (this.role.includes('firstGradeSupplier')) {
                this.goodsInfo.isShow = value;
            } else {
                this.goodsInfo.isTwoShow = value;
            }
        },

        // 数据回显
        async getGoodsInfo(id) {
            this.echoAfter = false;
            let {data} = await getSpaceStationDetailById({id});
            this.goodsInfo = data;
            this.echoAfter = true;
            this.destroyMap()
            this.$nextTick(() => {
                this.initMap()
            })

            await this.findCity(data.pro)
        },

        /**
         * 初始化地图
         */
        initMap() {
            //定义地图中心点坐标
            var center = new TMap.LatLng(this.goodsInfo.lat, this.goodsInfo.lng)
            //定义map变量，调用 TMap.Map() 构造函数创建地图
            this.map = new TMap.Map(document.getElementById('containerMaps'), {
                center: center,//设置地图中心点坐标
                zoom: 18
            });
            // 添加初始标记
            this.marker = new TMap.MultiMarker({
                map: this.map,
                styles: {
                    marker: new TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": {x: 16, y: 32}
                    })
                },
                geometries: [{
                    id: "marker",
                    styleId: "marker",
                    position: new TMap.LatLng(this.goodsInfo.lat, this.goodsInfo.lng)
                }]
            });

            this.map.on("click", (e) => {
                let {latLng}=e
                this.marker.setGeometries([{
                    id: "marker",
                    styleId: "marker",
                    position: new TMap.LatLng(latLng.lat, latLng.lng)
                }]);
                // 更新地图中心位置
                // this.map.setCenter(new TMap.LatLng(latLng.lat, latLng.lng));
            });

        },

        /**
         * 更新标记点位置
         */
        updateMarker() {
            this.marker.setGeometries([{
                id: "marker",
                styleId: "marker",
                position: new TMap.LatLng(this.goodsInfo.lat, this.goodsInfo.lng)
            }]);
            // 更新地图中心位置
            this.map.setCenter(new TMap.LatLng(this.goodsInfo.lat, this.goodsInfo.lng));
        },
        handleSelect(e) {
            this.mapLocation = {
                lat: e.location.lat,
                lng: e.location.lng
            }
            this.goodsInfo.storeCity = e.city
            this.goodsInfo.lat = this.mapLocation.lat
            this.goodsInfo.lng = this.mapLocation.lng
            this.goodsInfo.address = e.address
            this.updateMarker()
        },



        /**
         * 搜索
         */
        querySearchAsync(queryString, cb) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(async () => {
                let {data} = await getPlaceSuggestionApi({region: this.goodsInfo.storeCity, keyword: queryString})
                let arr = JSON.parse(data);
                cb(arr.data);
            }, 100);
        },

        /**
         * 删除地图
         */
        destroyMap() {
            if (this.map) {
                // 销毁地图实例
                this.map.destroy();
                this.map = null;
            }
        },


    },


    created() {

        this.initPro(0);

        this.destroyMap()

        if (this.$route.params.id) {
            let id = this.$route.params.id;
            if (!isNaN(id)) {
                this.getGoodsInfo(id);
            }

        }else{
            this.$nextTick(() => {
                this.initMap()
            })
        }
    },
    mounted() {
    },
    components: {uploadFileApi, Tinymce},
};
